import React from "react";
import { labelUtils } from "../Util";
import FormGroupWrapper from "./FormGroupWrapper";
import rootReducer from "../../../../store";
import { setRendererFormState } from "../../../../slices/common/reducer";
import { useEffect } from "react";
const TextField = ({
  arrEle,
  newElfromJSON,
  fieldEle,
  formState = {},
  displayLabelKey,
  databaseKey,
  showRequired = true,
}) => {
  let key = databaseKey ? databaseKey : displayLabelKey;

  const displayYes = fieldEle?.["display-yes"];
  const displayDependent = fieldEle?.["display-dependent"];
  // const parentSelectedValue = formState[displayYes || displayDependent] || "";

  // Visibility Logic
  let shouldDisplay = true;
  if (displayDependent) {
    const parentValue = formState[displayDependent];
    const displayIndex = fieldEle?.["display-index"];
    if (parentValue === undefined || parentValue === null || parentValue === "") {
      shouldDisplay = false;
    } else if (displayIndex !== undefined) {
      shouldDisplay = Number(parentValue) >= Number(displayIndex);
    } else {
      shouldDisplay = !!parentValue;
    }
  } else if (displayYes) {
    const parentValue = formState[displayYes];
    const legacyValues = ["yes", "other", "renewal", "active"];
    shouldDisplay = legacyValues.includes(parentValue?.toString().toLowerCase());
  }

  useEffect(() => {
    if ((displayYes || displayDependent) && shouldDisplay === false) {
      rootReducer.dispatch(
        setRendererFormState({ key: key, value: "" })
      );
    }
  }, [displayYes, displayDependent, shouldDisplay, key]);

  useEffect(() => {
    const defaultValue = fieldEle?.["default-value"];

    if (defaultValue && !formState[key]) {
      rootReducer.dispatch(
        setRendererFormState({
          key,
          value: defaultValue,
        })
      );
    }
  }, [key, fieldEle, formState[key]]);

  useEffect(() => {
    const parentKey = fieldEle["parent-key"];
    const parentValue = formState[parentKey];

    if (parentKey && parentValue && parentKey !== key && !formState[key]) {
      rootReducer.dispatch(
        setRendererFormState({
          key,
          value: parentValue,
        })
      );
    }
  }, [formState[fieldEle["parent-key"]]]);

  if (!shouldDisplay) {
    return null;
  }

  const defaultValue = fieldEle?.["default-value"] || "";

  return (
    <FormGroupWrapper
      arrEle={arrEle}
      newElfromJSON={newElfromJSON}
      fieldEle={fieldEle}
    >
      <div
        className="form-builder-element"
        style={{ width: labelUtils.getElementWidth(fieldEle) }}
      >
        <input
          id={newElfromJSON}
          className="form-control mandatory"
          type="text"
          placeholder={fieldEle?.["display-placeholder"]}
          disabled={fieldEle?.["display-disabled"] === 1}
          name={key}
          required={showRequired ? fieldEle?.["display-required"] === 1 : false}
          minLength={fieldEle?.["validation-minlength"]}
          maxLength={fieldEle?.["validation-maxlength"]}
          pattern={fieldEle?.["validation-pattern"]}
          // value={formState[key] || defaultValue}
          // value={
          //   formState[fieldEle["parent-key"]] || formState[key] || defaultValue
          // }
          // value={
          //   key === "proposal_filled"
          //     ? formState[key] === 1
          //       ? "Yes"
          //       : "No"
          //     : formState[fieldEle["parent-key"]] ||
          //       formState[key] ||
          //       defaultValue
          // }
          value={
            key === "proposal_filled"
              ? formState[key] === 1
                ? "Yes"
                : "No"
              : formState[key] || defaultValue
          }
          onChange={(e) => {
            if (fieldEle?.["validation-pattern"]) {
              let inputValue = e.target.value;
              let pattern = /^[a-zA-Z0-9._\-\s]*$/;

              if (!pattern.test(inputValue)) {
                e.target.setCustomValidity("No special characters allowed");
              } else {
                e.target.setCustomValidity("");
              }
            }
            rootReducer.dispatch(
              setRendererFormState({ key, value: e.target.value })
            );
          }}
        />
        <div className="invalid-feedback">This field is required</div>
        {fieldEle?.["display-description"] && (
          <div className="form-text text-muted formElementDesc">
            {fieldEle?.["display-description"]}
          </div>
        )}
      </div>
    </FormGroupWrapper>
  );
};

export default TextField;
